// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"cc958099","65":"ebf5b85e","170":"5a3e49c4","197":"31601b51","223":"8651eb86","319":"e1649f2e","453":"3f038b64","498":"96838e52","612":"8a109b4e","700":"bb6813c7","849":"56a3cf8b","908":"7c8e20d0"}[chunkId] + ".chunk.js";
};